export const LiveAPI = "https://drytechindia.com";
export const LocalAPI = "http://localhost:8080";